import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const RemarksModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // fields
    remarks, onRemarksChange, remarksError, setRemarksError,
    nodalExtTxnType, onNodalExtTxnTypeChange, nodalExtTxnTypeList, nodalExtTxnTypeError, setNodalExtTxnTypeError,
    reconciliationStatus
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Add remarks'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    {
      (reconciliationStatus === 'reconcile_failed' || reconciliationStatus == 'external_transfer') &&
      <InputSelectSF type='select' name='nodalExtTxnType' label='Transaction type'
        value={nodalExtTxnType} onChange={onNodalExtTxnTypeChange} optionList={nodalExtTxnTypeList}
        error={nodalExtTxnTypeError} setError={setNodalExtTxnTypeError}
      />
    }
    <InputTextAreaSF type='text' name='remarks' label='Internal remarks'
      value={remarks} onChange={onRemarksChange}
      error={remarksError} setError={setRemarksError}
      help='500 characters max'
    />
  </ModalFormUI>

export default RemarksModalUI
